export default __webpack_public_path__ + "static/media/homeimage.7a259a47.jpg";